module.exports = __webpack_public_path__ + "media/images/technology/detection-icon-b558489c7c4eddb3bf24cd7203f469ec.png";